import { STORAGE_KEY } from "@constants";
import type { AppDispatch } from "@stores";
import preferenceSlice from "@stores/preference/slices";
import type { BeforeInstallPromptEvent } from "kz-ui-sdk";
import { getPersistedDueAt } from "kz-ui-sdk";
import moment from "moment";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

/**
 * Captures the PWA `beforeinstallprompt` event and syncs installability + deferred prompt into Redux.
 * Headless; keep alongside AppUpdateDetector (same class of global browser hooks).
 */
const PwaInstallInterceptor = () => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const beforeInstallPromptHandler = (event: Event) => {
      event.preventDefault();
      const dueAt = getPersistedDueAt(STORAGE_KEY.PWA_REMINDER);
      if (dueAt && !moment().isAfter(dueAt)) {
        return;
      }
      sessionStorage.setItem(STORAGE_KEY.BEFORE_INSTALL_PROMPT_FIRED, "true");
      dispatch(preferenceSlice.actions.setIsAppInstallable(true));
      dispatch(preferenceSlice.actions.setAppInstallerPrompt(event as BeforeInstallPromptEvent));
    };

    window.addEventListener("beforeinstallprompt", beforeInstallPromptHandler);

    return () => {
      window.removeEventListener("beforeinstallprompt", beforeInstallPromptHandler);
    };
  }, [dispatch]);

  return null;
};

export default PwaInstallInterceptor;
